import React from 'react';
import { Button, Row, Col, FormGroup } from 'reactstrap';
import { Input } from '@availity/form';
import './RequestPreOrderEngagementAgreementModal.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { useStateSelector } from '../../../store/selectors';

interface PracticesFormProps {
    values: any;
    setFieldValue: (field: string, value: any) => void;
    selectedPracticeId: number;
}

const PracticesForm = (props: PracticesFormProps) => {
    const summary = useStateSelector((state) => state.userSummary.summary);
    const practicesThatCanNotBeSelected = (values: any) => {
        const practiceIdsThatAreInEngagement = (summary?.practices ?? [])
            .filter((practice: any) => practice.isInEngagement === true)
            .map((practice: any) => practice.id);
        if (
            !practiceIdsThatAreInEngagement.includes(props.selectedPracticeId)
        ) {
            practiceIdsThatAreInEngagement.push(props.selectedPracticeId);
        }
        const combinedIds = Array.from(
            new Set([
                ...practiceIdsThatAreInEngagement,
                ...(values.practices ?? []),
            ])
        );
        return combinedIds;
    };

    const handleRemovePractice = (
        index: number,
        values: any,
        setFieldValue: (field: string, value: any) => void
    ) => {
        const newPractices = [
            ...values.practices.slice(0, index),
            ...values.practices.slice(index + 1),
        ];
        setFieldValue('practices', newPractices);
    };

    const handleAddPractice = (
        values: any,
        setFieldValue: (field: string, value: any) => void
    ) => {
        const availablePractice = (summary?.practices ?? []).find(
            (practice: any) =>
                !practicesThatCanNotBeSelected(values).includes(practice.id)
        );
        if (availablePractice) {
            const newPractices = [...values.practices, availablePractice.id];
            setFieldValue('practices', newPractices);
        }
    };

    const handleChangePractice = (
        index: number,
        newId: number,
        values: any,
        setFieldValue: (field: string, value: any) => void
    ) => {
        const newPractices = [...values.practices];
        newPractices[index] = newId;
        setFieldValue('practices', newPractices);
    };

    return (
        <>
            {props.values.practices.map((practice: any, index: number) => (
                <Row key={index} className="align-items-center">
                    <Col xs={11} md={6}>
                        <FormGroup className="mb-2">
                            <Input
                                type="select"
                                name={`practices[${index}]`}
                                onChange={(event) => {
                                    handleChangePractice(
                                        index,
                                        Number(event.target.value),
                                        props.values,
                                        props.setFieldValue
                                    );
                                }}>
                                {summary?.practices.map((item: any) => (
                                    <option
                                        disabled={practicesThatCanNotBeSelected(
                                            props.values
                                        ).includes(item.id)}
                                        value={item.id}
                                        key={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col
                        xs={0.5}
                        className="d-flex justify-content-end align-items-center mb-2">
                        <FontAwesomeIcon
                            icon={faTrashCan}
                            className="delete-button"
                            onClick={() =>
                                handleRemovePractice(
                                    index,
                                    props.values,
                                    props.setFieldValue
                                )
                            }
                        />
                    </Col>
                </Row>
            ))}
            {summary?.practices.length >
                props.values.practices.length + 1 && (
                <div className="d-flex">
                    <Button
                        color="primary"
                        onClick={() =>
                            handleAddPractice(props.values, props.setFieldValue)
                        }>
                        Add Practice
                    </Button>
                </div>
            )}
        </>
    );
};

export default PracticesForm;
